import React from "react";
import {withRouter} from 'react-router-dom';

import queryString from 'qs'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import Subscriptions from "views/Components/Subscriptions"
import { getSearchString } from "../../../assets/helpers/urlHelper";

const style = {

};

class Plan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlanId: '',
      selectedPlanType: '',
      selectedSavingsAmount: 0,
      allowMonthlyPlans: '',
      allowAnnualPlans: '',
      providerId: ''
    };
  }
  sendState() {
    return this.state;
  }
  isValidated() {
    if (this.state.selectedPlanId === '') {
      return false
    }
    return true;
  }

  componentDidMount() {
    const searchString = getSearchString(this.props.location.search)
    const values = queryString.parse(searchString)
    if (values.provider && !isNaN(values.provider)) {
      this.setState({
        providerId: values.provider
      })
    }
  }

  componentDidUpdate(prevProps) {
    const priorSelectedProviderId = this.getSelectedParam(prevProps.allStates, 'provider', 'selectedProviderId')
    const selectedProviderId = this.getSelectedParam(this.props.allStates, 'provider', 'selectedProviderId')
    const priorSelectedProviderAllowMonthlyPlans = this.getSelectedParam(prevProps.allStates, 'provider', 'selectedProviderAllowMonthlyPlans')
    const selectedProviderAllowMonthlyPlans = this.getSelectedParam(this.props.allStates, 'provider', 'selectedProviderAllowMonthlyPlans')
    const priorSelectedProviderAllowAnnualPlans = this.getSelectedParam(prevProps.allStates, 'provider', 'selectedProviderAllowAnnualPlans')
    const selectedProviderAllowAnnualPlans = this.getSelectedParam(this.props.allStates, 'provider', 'selectedProviderAllowAnnualPlans')

    if (priorSelectedProviderAllowMonthlyPlans !== selectedProviderAllowMonthlyPlans ||
      priorSelectedProviderAllowAnnualPlans !== selectedProviderAllowAnnualPlans ||
      priorSelectedProviderId !== selectedProviderId) {
      this.setState({
        allowMonthlyPlans: selectedProviderAllowMonthlyPlans,
        allowAnnualPlans: selectedProviderAllowAnnualPlans,
        providerId: selectedProviderId
      })
    }

  }

  getSelectedParam(stateObj, key, subKey) {
    var selectedProviderId = ''
    var i;
    for (i = stateObj.length - 1; i >= 0; i--) {

      if (stateObj[i]) {
        var objectKey = Object.keys(stateObj[i])[0]
        if (objectKey === key) {
          selectedProviderId = stateObj[i][key][subKey]

          break;
        }
      }
    }
    return selectedProviderId;
  }


  selectPlan(planId, planType) {
    this.setState({
      selectedPlanId: planId,
      selectedPlanType: planType
    })
  }

  selectSavingsAmount(savingsAmount) {
    this.setState({
      selectedSavingsAmount: savingsAmount
    })
  }

  render() {
    return (
      <div>
        <Subscriptions
          providerId={this.state.providerId}
          editByOrg={this.state.editByOrg}
          cardTitle='What subscription would you like?'
          cardSubtitle='The subscription fee will be withdrawn from your account on or after the first of each month. You can change subscriptions anytime without any penalty or trouble.'
          showCardIcon={false}
          saveSelection={false}
          onSelectPlan={this.selectPlan.bind(this)}
          onSelectSavingsAmount={this.selectSavingsAmount.bind(this)}
          standardSelectText={true}
          allowMonthlyPlans={this.state.allowMonthlyPlans}
          allowAnnualPlans={this.state.allowAnnualPlans}
          getMemberPlanInfo={false}
        />
      </div>
    );
  }
}

export default withRouter(withStyles(style)(Plan));
